export enum BrainWritingMode {
  CONTINUE = 'CONTINUE',
  DRAFT_PROMPT = 'DRAFT_PROMPT',
  SUMMARIZE = 'SUMMARIZE',
  ASK_SPACES = 'ASK_SPACES',
  NOTES_TO_TABLE = 'NOTES_TO_TABLE',
  REWRITE = 'REWRITE',
  TONE = 'TONE',
  TRANSLATE = 'TRANSLATE',
  FIX_GRAMMAR = 'FIX_GRAMMAR',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
}

export enum BrainWritingTone {
  FORMAL = 'FORMAL',
  FRIENDLY = 'FRIENDLY',
  DIRECT = 'DIRECT',
  CONFIDENT = 'CONFIDENT',
}

export enum BrainWritingLanguage {
  PT_BR = 'PT_BR',
  ES = 'ES',
  EN_US = 'EN_US',
}

export interface GenerateBrainWritingInput {
  mode: BrainWritingMode;
  pageId: string;
  spaceId: string;
  pageTitle?: string;
  pageContent: string;
  prompt?: string;
  selection?: string;
  tone?: BrainWritingTone;
  targetLanguage?: BrainWritingLanguage;
}

export interface BrainWritingSource {
  pageId: string;
  spaceId: string;
  title: string;
}

export interface GenerateBrainWritingPayload {
  markdown: string;
  sources: BrainWritingSource[];
}
